import _defineProperty from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import { useEffect, useState } from 'react';
import { JoveGridItem } from '@jove-frontend/mui';
import { QuoteBillPaymentStatusEnum, useQuotePriceDetailInfo } from '@jove-frontend/uikit';
import { Box, Grid, Typography } from '@mui/material';
import clsx from 'clsx';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var PaymentScheduleUniversalItemView = function PaymentScheduleUniversalItemView(props) {
  var _useState2, _paymentStatusInfoMap, _paymentStatusInfoMap2;

  var info = props.info,
      className = props.className;

  var _useState = useState((_useState2 = {}, _defineProperty(_useState2, QuoteBillPaymentStatusEnum.SUCCEEDED, {
    backgroundColor: '#1CB258',
    text: 'Paid'
  }), _defineProperty(_useState2, QuoteBillPaymentStatusEnum.PENDING, {
    backgroundColor: '#E6C30C',
    text: 'Upcoming'
  }), _defineProperty(_useState2, QuoteBillPaymentStatusEnum.FAILED, {
    backgroundColor: '#DD1F1F',
    text: 'Failed'
  }), _defineProperty(_useState2, QuoteBillPaymentStatusEnum.CANCELED, {
    backgroundColor: '#E76F2B',
    text: 'Cancelled'
  }), _useState2)),
      paymentStatusInfoMap = _useState[0],
      setPaymentStatusInfoMap = _useState[1];

  return /*#__PURE__*/_jsx(Box, {
    className: clsx('flex flex-col items-center', className),
    children: /*#__PURE__*/_jsxs(Box, {
      className: "bg-light-purple relative flex w-full flex-col items-center overflow-hidden rounded-md py-3",
      children: [paymentStatusInfoMap[info === null || info === void 0 ? void 0 : info.payment_status] && /*#__PURE__*/_jsx(Box, {
        className: "absolute right-0 top-0 whitespace-nowrap rounded-bl-lg px-1 text-[10px] font-bold text-white",
        sx: {
          backgroundColor: (_paymentStatusInfoMap = paymentStatusInfoMap[info === null || info === void 0 ? void 0 : info.payment_status]) === null || _paymentStatusInfoMap === void 0 ? void 0 : _paymentStatusInfoMap.backgroundColor
        },
        children: (_paymentStatusInfoMap2 = paymentStatusInfoMap[info === null || info === void 0 ? void 0 : info.payment_status]) === null || _paymentStatusInfoMap2 === void 0 ? void 0 : _paymentStatusInfoMap2.text
      }), /*#__PURE__*/_jsx(Typography, {
        variant: "subtitle1",
        className: "font-bold",
        children: info === null || info === void 0 ? void 0 : info.content
      }), /*#__PURE__*/_jsx(Typography, {
        variant: "subtitle2",
        className: "font-medium",
        children: info === null || info === void 0 ? void 0 : info.title
      })]
    })
  });
};

export var PaymentScheduleUniversalView = function PaymentScheduleUniversalView(props) {
  var priceInfo = props.priceInfo,
      _props$mdColumns = props.mdColumns,
      mdColumns = _props$mdColumns === void 0 ? 2 : _props$mdColumns,
      _props$xsColumns = props.xsColumns,
      xsColumns = _props$xsColumns === void 0 ? 3 : _props$xsColumns,
      className = props.className;

  var _useQuotePriceDetailI = useQuotePriceDetailInfo(),
      generateQuotePricePaymentScheduleList = _useQuotePriceDetailI.generateQuotePricePaymentScheduleList;

  var _useState3 = useState([]),
      paymentScheduleList = _useState3[0],
      setPaymentScheduleList = _useState3[1];
  /**
   * effects
   */


  useEffect(function () {
    if (priceInfo) {
      generatePaymentScheduleInfoList();
    }
  }, [priceInfo]);
  /**
   * methods
   */

  var generatePaymentScheduleInfoList = function generatePaymentScheduleInfoList() {
    setPaymentScheduleList(generateQuotePricePaymentScheduleList({
      billingSchedule: priceInfo.billing_schedule
    }));
  };

  return /*#__PURE__*/_jsx(Box, {
    className: clsx('flex flex-col', className),
    children: paymentScheduleList.length === 1 ? /*#__PURE__*/_jsx(PaymentScheduleUniversalItemView, {
      className: "w-full",
      info: paymentScheduleList[0]
    }) : /*#__PURE__*/_jsx(Grid, {
      container: true,
      spacing: 2,
      children: paymentScheduleList.map(function (item, index) {
        return /*#__PURE__*/_jsx(Grid, {
          item: true,
          md: mdColumns,
          xs: xsColumns,
          children: /*#__PURE__*/_jsx(JoveGridItem, {
            children: /*#__PURE__*/_jsx(PaymentScheduleUniversalItemView, {
              info: item
            })
          })
        }, index);
      })
    })
  });
};